window.addEventListener("load", function () {

    $(".list-qua [class^='qua-']").each(function () {
        const $textAuto = $(this).find(".text-auto");
        if ($(this).hasClass("received")) {
            $textAuto.text($textAuto.data("received"));
        } else {
            $textAuto.text($textAuto.data("default"));
        }
    });
});